var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon2);
export default __webpack_public_path__ + "static/media/login-icon2.0f2219fd2683ae2d280357b9328aa8c8.svg";
export { ForwardRef as ReactComponent };